import type { Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core'
import { useTrialDashboardDesktopTypographyStyles } from '../../shared/useTrialDashboardDesktopTypographyStyles'

const responsiveSpacing = 'clamp(40px, 5vw, 150px)'

const useLayoutStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(4),
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(6),
    minHeight: 'calc(100vh - 200px)',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    overflow: 'visible',
    width: '100%',
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(3),
      gap: theme.spacing(4),
      minHeight: 'calc(100vh - 200px)'
    },
    [theme.breakpoints.up('lg')]: {
      minHeight: 'calc(100vh - 200px)',
      gap: theme.spacing(6)
    }
  },
  whiteBackground: {
    position: 'absolute',
    width: 'calc(100% + 64px)',
    maxWidth: 'none',
    height: 'auto',
    minHeight: '347.452px',
    flexShrink: 0,
    border: '1.19px solid #D9DEE8',
    backgroundColor: '#FFFFFF',
    zIndex: 0,
    top: '40%',
    left: 'calc(50% - 32px)',
    transform: 'translate(-50%, -50%)',
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
    borderRadius: theme.shape.borderRadius,
    display: 'block',
    visibility: 'visible',
    opacity: 1,
    pointerEvents: 'none',
    paddingTop: 0,
    paddingRight: '50px',
    paddingBottom: 0,
    paddingLeft: '50px',
    boxSizing: 'border-box',
    [theme.breakpoints.down('md')]: {
      width: 'calc(100vw - 64px)',
      maxWidth: '832.074px',
      minHeight: '303.083px',
      padding: theme.spacing(3)
    },
    [theme.breakpoints.up('lg')]: {
      width: 'calc(100% + 64px)',
      maxWidth: 'none',
      left: 'calc(50% - 32px)',
      transform: 'translate(-50%, -50%)',
      paddingTop: 0,
      paddingRight: '50px',
      paddingBottom: 0,
      paddingLeft: '50px',
      overflow: 'hidden'
    },
    '@media (min-width: 1214px)': {
      paddingRight: '50px',
      paddingLeft: '50px'
    },
    [theme.breakpoints.up('xl')]: {
      width: 'calc(100% + 64px)',
      maxWidth: 'none',
      left: 'calc(50% - 32px)',
      transform: 'translate(-50%, -50%)',
      borderRadius: theme.shape.borderRadius,
      paddingTop: 0,
      paddingRight: '50px',
      paddingBottom: 0,
      paddingLeft: '50px',
      overflow: 'hidden'
    }
  },
  leftSection: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    position: 'absolute',
    top: '40%',
    left: 0,
    transform: 'translateY(-50%)',
    zIndex: 2,
    maxWidth: '690.926px',
    padding: 0,
    marginLeft: 0,
    flexShrink: 1,
    minWidth: 0,
    width: '50%',
    [theme.breakpoints.down('md')]: {
      maxWidth: '100%',
      padding: theme.spacing(2),
      position: 'relative',
      top: 'auto',
      transform: 'none',
      width: '100%'
    },
    [theme.breakpoints.up('lg')]: {
      maxWidth: '600px',
      flexShrink: 1
    },
    [theme.breakpoints.up('xl')]: {
      position: 'absolute',
      top: '40%',
      left: 0,
      transform: 'translateY(-50%)',
      maxWidth: '600px',
      flexShrink: 1
    },
    '@media (min-width: 1850px)': {
      maxWidth: '690.926px'
    }
  },
  leftSectionContent: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    paddingTop: '50px',
    boxSizing: 'border-box',
    [theme.breakpoints.up('lg')]: {
      paddingTop: '50px',
      paddingLeft: '50px',
      paddingRight: 0
    },
    '@media (min-width: 1214px)': {
      paddingLeft: responsiveSpacing,
      paddingRight: 0
    }
  },
  rightSection: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    top: '40%',
    right: 0,
    transform: 'translateY(-50%)',
    zIndex: 2,
    paddingRight: '50px',
    flexShrink: 1,
    minWidth: 0,
    width: '50%',
    [theme.breakpoints.up('lg')]: {
      paddingRight: '50px',
      boxSizing: 'border-box'
    },
    '@media (min-width: 1214px)': {
      paddingRight: '50px'
    },
    [theme.breakpoints.up('xl')]: {
      position: 'absolute',
      top: '40%',
      right: 0,
      transform: 'translateY(-50%)',
      paddingRight: '50px',
      boxSizing: 'border-box',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }
}))

export const useSherwinTrialOverDashboardDesktopLayoutStyles = () => {
  const layoutStyles = useLayoutStyles()
  const typographyStyles = useTrialDashboardDesktopTypographyStyles()
  return { ...layoutStyles, ...typographyStyles }
}
